import RestService from '../services/rest';

async function getWaybillsByDate(startDate, endDate) {
  return RestService.getAuthenticated(`waybill/listByDate?filterStartDate=${startDate}&filterEndDate=${endDate}`);
}

async function syncWaybillErp(waybillId) {
  return RestService.postAuthenticated('waybill/syncErp', { waybillId });
}

async function generateManualWaybill(outboundOrderIds, branchCode, carrierCode) {
  return RestService.postAuthenticated('waybill/generateManualWaybill', { outboundOrderIds, branchCode, carrierCode });
}

async function deleteManualWaybill(waybillId) {
  return RestService.deleteAuthenticated('waybill/deleteManualWaybill', { waybillId });
}

export default {
  getWaybillsByDate,
  syncWaybillErp,
  generateManualWaybill,
  deleteManualWaybill,
};
